import { Component, Input } from '@angular/core';

export type SiteSetupStage = 'identity' | 'catalog' | 'store' | 'domain' | 'complete';

/** Decorative, code-native artwork shared by shop creation and its real progress states. */
@Component({
  selector: 'app-site-setup-illustration',
  standalone: true,
  templateUrl: './site-setup-illustration.component.html',
  styleUrls: ['./site-setup-illustration.component.scss'],
})
export class SiteSetupIllustrationComponent {
  @Input() stage: SiteSetupStage = 'identity';
  @Input() shopName = '';
  @Input() paused = false;
  @Input() animated = false;
}
